import * as React from 'react'

// hooks
import useStreamActions from '../../../hooks.stream/useStreamActions';

// configs
import project from '../../../configs/project';

// rsuite
import { Navbar, Nav, Button } from 'rsuite';
import CheckRoundIcon from '@rsuite/icons/CheckRound';


export default function Appbar() {

  // hooks
  const streamActions = useStreamActions()

  const toolsMenu = [
    {
      title: 'Restart stream',
      onClick: () => {
        streamActions.reconnect()
      }
    },
    {
      title: 'Reset resolution',
      onClick: () => {
        streamActions.resetResolution()
      }
    },
  ]

  return (
    <Navbar appearance="subtle">
      <Navbar.Brand as="a" href={project.urls.main} target="_blank">
        {project.name} v{project.package.version}
      </Navbar.Brand>
      <Nav onSelect={() => { }} activeKey={undefined}>

        {/* <Nav.Item>Project</Nav.Item> */}

        <Nav.Menu title="Tools">
          {toolsMenu.map((item, index) => {
            return (
              <Nav.Item key={index} onClick={item.onClick}>
                {item.title}
              </Nav.Item>
            )
          })}
        </Nav.Menu>
        <Nav.Menu title="Help">
          <Nav.Item as="a" href={project.urls.docs} target="_blank">
            Documentation
          </Nav.Item>
          <Nav.Item as="a" href={project.urls.support} target="_blank">
            Support
          </Nav.Item>
        </Nav.Menu>
      </Nav>
      <Nav pullRight>
        <Nav.Item as="a" href={project.urls.buy} target="_blank">
          <Button color="green" appearance="primary" startIcon={<CheckRoundIcon />}>
            Buy Pro
          </Button>
        </Nav.Item>
      </Nav>
    </Navbar>

  )
}